import {IObjectData, TSyncfield} from "../../index";
import {createErrorString, getObjectDisplayName, getSyncFieldValue} from "../../util/misc";
import {getHash} from "../../constants/RouteDefinitions";
import list_user_itemHtml from './list-user-item.html?raw';

export const template = list_user_itemHtml;

interface IParams {
    user: IObjectData
    reason?: string
}

export class viewModel {
    private user: IObjectData;
    private reason: string;
    constructor(private params: IParams) {
        this.user = params.user
        this.reason = params.reason ?? '';
    }

    private getDisplayName() {
        const gn = getSyncFieldValue('GivenName', this.user.syncfields);
        const sn = getSyncFieldValue('Surname', this.user.syncfields);
        return gn + ' ' + sn;
    }

    private createErrorString(reason: string): string {
        return createErrorString(reason, '_blank')
    }

    private getLinkToUser(): string {
        return getHash('userdetails', {id: this.user.id}, true, this.user.orgnr ?? '') ?? '';
    }

}